import { SERVER_URL } from 'Constants/Server'
import axios from 'axios'

export const deleteMembersOfAHouse = async (houseId) => {
  const url = `${SERVER_URL}/api/Houses/${houseId}/houseMembers`
  const response = await axios.delete(url)
  return response.data
}
